(function () {
  'use strict';

  var label = 'View product';

  if (window.Theme && Theme.localization && Theme.localization.product) {
    label = Theme.localization.product.viewProduct || label;
  }

  var CARD_SELECTOR = [
    'article.product-item[data-product-item]',
    'article[data-product-item].product-item',
    '[data-product-item].product-item',
    '.spf-product-card'
  ].join(', ');

  var GRID_SELECTORS = [
    '#gf-products',
    '[data-globo-filter-items]',
    '.collection-main-wrapper',
    '.search-wrapper',
    '#CollectionProductGrid'
  ];

  var ATC_SELECTOR = [
    'button.spf-product__form-btn-addtocart',
    '.spf-product__form-btn-addtocart[type="submit"]',
    '[data-add-to-cart]',
    '.spf-add-to-cart',
    '.gspf-add-to-cart'
  ].join(', ');

  var GLOBO_EVENTS = [
    'globoFilterRendered',
    'globoFilterRenderCompleted',
    'globoFilterUpdated',
    'globo.filter.rendered',
    'globo.filter.render.completed'
  ];

  var initialized = false;
  var pollTimer = null;
  var pollAttempts = 0;

  function getGrids() {
    var grids = [];
    var seen = new Set();

    for (var i = 0; i < GRID_SELECTORS.length; i++) {
      document.querySelectorAll(GRID_SELECTORS[i]).forEach(function (node) {
        if (!seen.has(node)) {
          seen.add(node);
          grids.push(node);
        }
      });
    }

    return grids;
  }

  function getProductUrl(card) {
    var selectors = [
      '.product-item-title a[href*="/products/"]',
      '.spf-product-card__title a[href*="/products/"]',
      'h4 a[href*="/products/"]',
      'h3 a[href*="/products/"]',
      'a[href*="/products/"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var link = card.querySelector(selectors[i]);

      if (link && link.getAttribute('href')) {
        return link.getAttribute('href');
      }
    }

    return null;
  }

  function createViewLink(url) {
    var viewLink = document.createElement('a');
    viewLink.href = url;
    viewLink.className = 'ecc-collection-view-product spf-product__form-btn-addtocart collection-view-product';
    viewLink.setAttribute('data-view-product', '');
    viewLink.setAttribute('data-ecc-view-product', '');
    viewLink.textContent = label;
    return viewLink;
  }

  function hideQuickView(card) {
    card.querySelectorAll('.open-quick-view, [onclick*="quickView"]').forEach(function (node) {
      node.remove();
    });
  }

  function removeAddToCart(card) {
    card.querySelectorAll(ATC_SELECTOR).forEach(function (button) {
      if (!button.classList.contains('collection-view-product') && !button.hasAttribute('data-ecc-view-product')) {
        button.remove();
      }
    });
  }

  function removePlainViewLinks(card) {
    card.querySelectorAll('.product-item-details-secondary > a, .product-item-details > a').forEach(function (link) {
      if (link.classList.contains('collection-view-product') || link.hasAttribute('data-ecc-view-product')) {
        return;
      }

      if (/view product/i.test((link.textContent || '').trim())) {
        link.remove();
      }
    });
  }

  function insertViewProduct(card, viewLink) {
    var wrap = document.createElement('div');
    wrap.className = 'collection-view-product-wrap';
    wrap.setAttribute('data-ecc-view-product-wrap', '');
    wrap.appendChild(viewLink);

    var imageWrapper = card.querySelector('figure.product-item-image, .product-item-image, .spf-product-card__image-wrapper');

    if (imageWrapper) {
      if (!imageWrapper.style.position || imageWrapper.style.position === 'static') {
        imageWrapper.style.position = 'relative';
      }

      imageWrapper.appendChild(wrap);
      return true;
    }

    var inner = card.querySelector('.spf-product-card__inner, .product-item__wrapper');

    if (inner) {
      inner.appendChild(wrap);
      return true;
    }

    card.appendChild(wrap);
    return true;
  }

  function ensureViewProduct(card) {
    hideQuickView(card);
    removeAddToCart(card);
    removePlainViewLinks(card);

    if (card.querySelector('[data-ecc-view-product-wrap]')) {
      return true;
    }

    var url = getProductUrl(card);

    if (!url) {
      return false;
    }

    return insertViewProduct(card, createViewLink(url));
  }

  function refreshGrid(grid) {
    var cards = grid.querySelectorAll(CARD_SELECTOR);
    var updated = 0;

    for (var i = 0; i < cards.length; i++) {
      if (ensureViewProduct(cards[i])) {
        updated += 1;
      }
    }

    return updated;
  }

  function refreshAll() {
    var grids = getGrids();
    var updated = 0;

    if (!grids.length) {
      updated = refreshGrid(document.body);
    } else {
      for (var i = 0; i < grids.length; i++) {
        updated += refreshGrid(grids[i]);
      }
    }

    return updated;
  }

  function bindGrid(grid) {
    refreshGrid(grid);

    if (grid.getAttribute('data-ecc-view-product-bound') === 'true') {
      return;
    }

    grid.setAttribute('data-ecc-view-product-bound', 'true');

    new MutationObserver(function () {
      refreshGrid(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  function init() {
    var grids = getGrids();

    if (!grids.length) {
      refreshAll();
      return;
    }

    for (var i = 0; i < grids.length; i++) {
      bindGrid(grids[i]);
    }
  }

  function scheduleInit() {
    init();

    if (refreshAll() > 0 && pollTimer) {
      window.clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function startPolling() {
    if (pollTimer) {
      return;
    }

    pollTimer = window.setInterval(function () {
      pollAttempts += 1;
      scheduleInit();

      if (pollAttempts >= 60) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 500);
  }

  function boot() {
    if (initialized) {
      scheduleInit();
      return;
    }

    initialized = true;
    scheduleInit();
    startPolling();

    for (var i = 0; i < GLOBO_EVENTS.length; i++) {
      document.addEventListener(GLOBO_EVENTS[i], scheduleInit);
      window.addEventListener(GLOBO_EVENTS[i], scheduleInit);
    }

    if (window.MutationObserver) {
      new MutationObserver(function () {
        var gfProducts = document.getElementById('gf-products');

        if (gfProducts && !gfProducts.getAttribute('data-ecc-view-product-bound')) {
          bindGrid(gfProducts);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  window.eccRefreshCollectionGrid = scheduleInit;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
